/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  type PagedResultDto_GetTaxItemDto,
  TaxItemService,
} from '../../services/wealthlane-tax-services';

const useGetTaxSetupList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<PagedResultDto_GetTaxItemDto | undefined, unknown> => {
  const {
    type: incomeYTDTypeId,
    taxPeriodId,
    taxApprovalStatusId,
    filter,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;
  const taxSetupList = useQuery(['getTaxSetupList', tableInfo], async () => {
    return await handleRequest(
      TaxItemService.getApiTaxApiAppTaxItemTaxItemList(
        taxPeriodId,
        taxApprovalStatusId,
        incomeYTDTypeId,
        filter,
        sorting,
        skipCount,
        maxResultCount
      )
    );
  });

  return taxSetupList;
};

export default useGetTaxSetupList;
